<script lang="ts" setup>
import { stripHtml } from '@general-function'
import { isValidUrl } from '@ui/helpers/functions'
import { useDataHeader } from '@/composables/useDataHeader'
import { useDataFooter } from '@/composables/useDataFooter'
import { getPagesTemplates } from '@/composables/usePages'

defineProps({
  color: {
    type: String,
    default: 'black',
  },
})

const {
  menuBottom,
  menuGeneral,
  menuGeneralTerms,
  dataHiddenNews,
} = useDataFooter()

const {
  checkMenu,
  localePath,
} = useDataHeader()

const menuTemplate = getPagesTemplates()
</script>

<template>
  <div class="none hidden w-0 opacity-0">
    <ul v-if="menuTemplate && menuTemplate.length">
      <template
        v-for="(item, i) in menuTemplate" :key="i"
      >
        <li
          v-if="item?.slug && checkMenu(item?.slug) && !item.is_spa"
        >
          <NuxtLink
            :to="localePath({
              name: item.slug,
              params: {
                slug: item?.child,
              },
            })"
            :title="stripHtml(item.title, false)"
          >
            {{ stripHtml(item.title, false) }}
          </NuxtLink>
        </li>
      </template>
    </ul>
    <ul
      v-if="(menuBottom && menuBottom.length)"
    >
      <li
        v-for="(el, index) in menuBottom"
        :key="index"
      >
        <NuxtLink
          v-if="el?.slug && !isValidUrl(el?.slug)"
          :to="localePath({
            name: 'general-terms-slug',
            params: {
              slug: el.slug,
            },
          })"
          :aria-label="stripHtml(el.title, false)"
          :title="stripHtml(el.title, false)"
          v-html="stripHtml(el.title as string, false)"
        >
        </NuxtLink>
      </li>
      <li
        v-if="menuGeneral && menuGeneral.length && (!menuGeneralTerms || menuGeneralTerms.length === 0)"
      >
        <NuxtLink
          :to="localePath({
            name: 'general-terms',
          })"
          aria-label="General Terms"
          title="General Terms"
          v-html="'General Terms'"
        >
        </NuxtLink>
      </li>
    </ul>
    <template v-if="Array.isArray(dataHiddenNews) && dataHiddenNews.length">
      <div
        v-for="(item, index) in dataHiddenNews"
        :key="index"
      >
        <NuxtLink
          :to="localePath({
            name: 'whats-new-detail',
            params: {
              slug: item.slug,
            },
          })"
        >
          {{ stripHtml(item.press_title, false) }}
        </NuxtLink>
      </div>
    </template>
  </div>
</template>
